module.exports = __webpack_public_path__ + "DCA Product Card.pdf";